module.exports = __webpack_public_path__ + "static/media/TUSA-aboutus-corevalues-hero-1440x550.b335b199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TUSA-aboutus-corevalues-hero-1440x550.jpg
// module id = 300
// module chunks = 0